import * as signalR from "@microsoft/signalr"
import { IS_PROD } from "./constants"

const connection = (url: $TSMigrationFixMe, config: $TSMigrationFixMe) =>
  new signalR.HubConnectionBuilder()
    .withUrl(url, config)
    .withAutomaticReconnect()
    .configureLogging(IS_PROD ? signalR.LogLevel.None : signalR.LogLevel.None)
    .build()

const createSignalInstace = ({ baseURL, hub, token }: $TSMigrationFixMe) =>
  connection(`${baseURL}/${hub}`, {
    transport: signalR.HttpTransportType.WebSockets,
    accessTokenFactory: () => token,
  })

export const createConnection = ({ hub, baseURL }: $TSMigrationFixMe) => {
  return createSignalInstace({
    baseURL,
    hub,
    token: sessionStorage.getItem("access_token"),
  })
}
